let CancelToken = class {
    constructor() {
        let resolve = null;
        let reject = null;
        let promise = new Promise((_resolve, _reject) => {
            resolve = _resolve;
            reject = _reject;
        });
        promise.catch(Function.prototype);
        this.isAbort = false;
        this.resolve = resolve;
        this.eraser = this.reject = this.cancel = this.abort = () => {
            this.isAbort = true;
            reject();
        };
        this.p = this.promise = promise;
    }
};

let asyncEraser = function (genFn, cancelToken) {
    // 从外面取消
    let ctx = this;

    return function (...arg) {
        let gen = genFn.call(ctx, ...arg); // call 不 call 的 感觉区别不大啊 老铁 咋回事啊 后面瞅瞅啊 哦 是vue内部bind了
        let genReturn = gen.return.bind(gen);

        if (cancelToken instanceof CancelToken) {
            cancelToken.promise.catch(() => {
                genReturn('cancelToken abort');
            });
        }

        let nextCnt = 0;

        let resPromise = new Promise((resolve, reject) => {
            // 代替我们去掉用gen的next
            function runner(thenVal) {
                let result = gen.next(thenVal);
                nextCnt++;
                wait(result);
            }

            runner('first Run');

            // 等待Promise resolve的
            function wait(nextResult) {
                if (nextResult.done) {
                    return resolve(nextResult.value);
                }
                let value = Promise.resolve(nextResult.value);
                let t = Date.now();
                let _t = performance.now();
                value.then((val) => {
                    // console.log('async-eraser', Date.now() - t, performance.now() - _t);
                    runner(val);
                })
                // return value.then(runner);
            }
        });

        resPromise.return = genReturn;
        return resPromise;
    }
};
asyncEraser.CancelToken = CancelToken;

export default asyncEraser;
